<div class="authentication-bg min-vh-100">
  <div class="bg-overlay bg-white"></div>
  <!-- Language Switcher -->
  <div class="language-switcher-container">
    <app-language-switcher></app-language-switcher>
  </div>
  <div class="container">
    <div class="col-row">
      <div class="col-md-6">
        <div class="w-full">
          <div class="mb-4 mb-md-5 responsive-auth-header">
            <a routerLink="/" class="d-block auth-logo">
              <div class="d-flex gap-3">
                <img src="assets/images/HC-logo.svg" alt="HotelCard Logo" class="logo" />
                <img src="assets/images/hotelcard-text.svg" alt="HotelCard" class="hotelcard-text" />
                <span class="mt-3 responsive-divider">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="2"
                    height="30"
                    viewBox="0 0 2 30"
                    fill="none"
                  >
                    <path d="M1.24854 2.18557e-08L1.24853 30" stroke="white" />
                  </svg>
                </span>
                <span class="text-white extranet">Extranet</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-column">
      <div class="row justify-content-center my-auto">
        <div class="col-lg-6">
          <div class="responsive-center-card responsive-auth-page-card">
            <div class="card auth-cover-card overflow-hidden">
              <div class="row g-0">
                <!-- end col -->
                <div class="col-lg-12">
                  <div
                    class="login-form-card bg-white h-100 d-flex align-items-center justify-content-center auth-card"
                  >
                    <div class="w-full">
                      <div class="text-white-50 mb-4">
                        <h5 class="welcome-text">{{ 'AUTH.LOGIN.TITLE' | translate }}</h5>
                      </div>
                      @if (showSessionExpired) {
                        <div class="alert alert-warning mb-3">
                          <lucide-icon name="clock" class="me-2"></lucide-icon>{{ 'AUTH.LOGIN.SESSION_EXPIRED' | translate }}
                        </div>
                      }
                      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                        <hc-form-field
                          [label]="'AUTH.LOGIN.EMAIL_LABEL' | translate"
                          [required]="true"
                          [error]="submitted && f['name'].errors
                            ? (f['name'].errors['required']
                              ? ('AUTH.COMMON.EMAIL_REQUIRED' | translate)
                              : ('AUTH.COMMON.EMAIL_INVALID' | translate))
                            : ''">
                          <hc-input
                            type="email"
                            formControlName="name"
                            [placeholder]="'AUTH.LOGIN.EMAIL_PLACEHOLDER' | translate"
                            [hasError]="!!(submitted && f['name'].errors)">
                          </hc-input>
                        </hc-form-field>

                        <hc-form-field
                          [label]="'AUTH.LOGIN.PASSWORD_LABEL' | translate"
                          [required]="true"
                          [error]="submitted && f['password'].errors
                            ? ('AUTH.COMMON.PASSWORD_REQUIRED' | translate)
                            : ''">
                          <hc-input
                            type="password"
                            autocomplete="current-password"
                            formControlName="password"
                            [placeholder]="'AUTH.LOGIN.PASSWORD_PLACEHOLDER' | translate"
                            [hasError]="!!(submitted && f['password'].errors)">
                          </hc-input>
                        </hc-form-field>

                        <a
                          routerLink="/account/forgot-password"
                          class="text-decoration-underline forgot-password mt-4"
                        >{{ 'AUTH.LOGIN.FORGOT_PASSWORD' | translate }}
                        </a>

                        <!-- Remember Me Checkbox with formControlName -->
                        <div class="mt-4 d-flex align-items-center">
                          <hc-checkbox
                            [label]="'AUTH.LOGIN.REMEMBER_ME' | translate"
                            formControlName="rememberMe">
                          </hc-checkbox>
                          <lucide-icon
                            name="info"
                            class="ms-1 text-muted cursor-pointer"
                            [ngbTooltip]="'AUTH.LOGIN.REMEMBER_ME_HINT' | translate"
                            placement="top">
                          </lucide-icon>
                        </div>

                        @if (error) {
                          <div class="alert alert-danger mt-3 mb-0">
                            {{ error }}
                          </div>
                        }

                        <div class="mt-4">
                          <hc-button
                            variant="primary"
                            type="submit"
                            size="md"
                            [fullWidth]="true"
                            [disabled]="loading"
                            [loading]="loading">
                            {{ loading ? ('AUTH.LOGIN.LOGGING_IN' | translate) : ('AUTH.LOGIN.SUBMIT' | translate) }}
                          </hc-button>
                        </div>

                        <p class="mt-5 responsive-register">
                          {{ 'AUTH.LOGIN.REGISTER_PROMPT' | translate }}
                          <a
                            routerLink="/account/register"
                            class="fw-medium text-decoration-underline register-hotel"
                          >{{ 'AUTH.LOGIN.REGISTER_LINK' | translate }}</a>
                        </p>

                        <p>
                          Check guest's HotelCard status?
                          <a
                            href="javascript:void(0)"
                            (click)="openCardValidityDialog()"
                            [attr.aria-label]="'dashboard.verify_card.title' | translate"
                            class="fw-medium text-decoration-underline register-hotel"
                          >Verify HotelCard</a>
                        </p>
                      </form>

                      <!-- end form -->
                    </div>
                  </div>
                </div>
                <!-- end col -->
              </div>
              <!-- end row -->
            </div>
            <!-- end card -->
          </div>
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
  </div>
  <!-- end container -->
</div>
<!-- end authentication section -->
